import React from 'react';

import { compose } from 'redux';

import { Box, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';

const styles = {
    loader: {
        position: 'absolute',
        left: '50%',
        top: '50%'
    },
};

const GeneralProgressBar = ({ classes }) => (
    <Box className={classes.loader}>
        <CircularProgress />
    </Box>
);

export default compose(withStyles(styles))(GeneralProgressBar);
